// extracted by mini-css-extract-plugin
export var logo = "index-module--logo--2zmUG";
export var links = "index-module--links--sS1cK";
export var footer = "index-module--footer--iZ-vb";
export var footerContent = "index-module--footerContent--t_rqC";